import { number, object, string, union, z } from "zod";

export const PromoCodeResponseDtoSuccess = object({
  requestDTO: object({
    dataMap: object({
      result: number().optional(), // 10,
      //isMirror: false,
      //actualDate: "Mar 26, 2025 12:53:24 PM",
      //message: "1234", // entered promo code
    }),
    //processorClass: "PromoCode",
  }),
});

export const PromoCodeResponseDtoError = object({
  requestDTO: object({
    dataMap: object({
      // actualDate: "Mar 22, 2025 1:27:48 PM",
      error: string(),
    }),
  }),
});

export const PromoCodeResponseDto = union([
  PromoCodeResponseDtoError,
  PromoCodeResponseDtoSuccess,
]);

export type PromoCodeResponseDtoSuccess = z.infer<
  typeof PromoCodeResponseDtoSuccess
>;

export type PromoCodeResponseDtoError = z.infer<
  typeof PromoCodeResponseDtoError
>;

export type PromoCodeResponseDto = z.infer<typeof PromoCodeResponseDto>;
